import { Leva } from 'leva';
import { Renderer } from './canvas/Renderer';
import { Hud } from './ui/Hud';
import { DebugPanel } from './ui/DebugPanel';
import { XRButtons } from './xr/XRWrapper';

export default function App() {
  return (
    <>
      <Renderer />
      <Hud />
      <XRButtons />
      <DebugPanel />
      {/* Leva controls registered via DebugPanel but UI hidden in production */}
      <Leva hidden />
    </>
  );
}
